import { languageService } from "../Language/language.service";
import { arrayToCsv } from "./arrayToCsv";
import { ToastService } from "./toastify";

export const downloadCsv = (rows, doc, filename, recordStatus, extraHeader, extraFooter) => {
  if (rows && rows.length > 0) {
    let csv = arrayToCsv(rows);
    if (extraHeader) {
      csv = extraHeader + "\r\n" + csv;
    }
    if (extraFooter) {
      csv = csv + "\r\n" + extraFooter;
    }

    var hiddenElement = doc.createElement("a");
    var universalBOM = "\uFEFF";
    hiddenElement.href = "data:text/csv; charset=utf-8," + encodeURIComponent(universalBOM + csv);
    hiddenElement.target = "_blank";
    // provide the name for the CSV file to be downloaded
    hiddenElement.download = `${filename}.csv`;
    hiddenElement.click();
    ToastService.Success(
      `${languageService("Successfully exported")} ${rows.length} ${recordStatus ? recordStatus : ""} ${languageService("records to")} '${
        hiddenElement.download
      }'.`,
    );
  } else {
    ToastService.Info(`${languageService("No Records Available")}!`);
  }
};



// WEBPACK FOOTER //
// ./src/utils/downloadCsv.js